/**
 * Tutor Tips config service — US-001 / T-service / API-001.
 *
 * Mirrors billing.ts (getTopupPacks) exactly:
 *   - uses shared axios instance (attaches Authorization: Bearer {idToken} automatically)
 *   - errors propagate — never swallowed here (KB TO-LL-036); the hook handles fallback
 *
 * Pattern evidence: frontend/src/services/billing.ts L34–37 (getTopupPacks)
 */

import { api } from '@/lib/api';
import type { TutorTipsConfig } from '@/types/tutorTips';

/**
 * GET /system-config/tutor-tips (API-001).
 * Returns the tip popup countdown configuration.
 * Errors propagate to React Query — never swallowed (KB TO-LL-036).
 */
export async function getTutorTipsConfig(): Promise<TutorTipsConfig> {
  const response = await api.get<TutorTipsConfig>('/system-config/tutor-tips');
  return response.data;
}
